import { useState } from 'react';

type DynamicConfigsDialog = {
	open: boolean;
	handleSetOpen: (state: boolean) => void;
};

export const useDynamicConfigsDialog = (): DynamicConfigsDialog => {
	const [open, setOpen] = useState(false);

	const handleSetOpen = (state: boolean) => {
		setOpen(state);
	};

	return {
		open,
		handleSetOpen,
	};
};

export default useDynamicConfigsDialog;
